import { useState } from 'react';
import * as _ from 'lodash';
import { Box, Flex, Heading, Button, Icon, Divider } from '@vibe/core';
import { type MondayClient } from '@gorilla/common/src/lib/monday-api/common';
import { BoardDiagnoseModal } from './BoardDiagnoseModal';
import { Alert, Board } from '@vibe/icons';

function createErrorJson(error: any, mondayClient?: MondayClient) {
  const time = new Date().toISOString();
  const errorHistory = mondayClient?.getErrorQueryHistory();
  const requesterErrorResult = error?.requesterErrorResult;

  return {
    time,
    message: error.message,
    boardId: error.boardId,
    stack: error.stack,
    name: error.name,
    requesterErrorResult,
    history: errorHistory,
  };
}
interface ErrorMessageProps {
  title?: string;
  mondayClient?: MondayClient;
  error: any;
}

export function ErrorBox({ error, mondayClient, title = 'An Error occured' }: ErrorMessageProps) {
  const [showBoardDiagnoseModal, setShowBoardDiagnoseModal] = useState(false);
  const humanErrors = _.get(error, 'requesterErrorResult.humanErrors') || [];
  const boardId = _.get(error, 'boardId');
  let errorMessage = humanErrors?.length
    ? humanErrors.map((message: string) => message).join(', ')
    : _.get(error, 'message') || 'unknown error occurred';

  if (boardId) {
    errorMessage = `Error while querying board ${boardId}: ${errorMessage}`;
  }

  return (
    <>
      {showBoardDiagnoseModal && boardId && mondayClient ? (
        <BoardDiagnoseModal
          boardId={boardId}
          mondayClient={mondayClient}
          onClose={() => {
            setShowBoardDiagnoseModal(false);
          }}
        />
      ) : null}
      <Box margin="medium" style={{ zIndex: 10000, position: 'relative' }}>
        <Flex direction="column" gap={24}>
          <div
            style={{
              overflow: 'hidden',
              //padding: '24px 28px',
              //width: 'calc(100% - 58px)',
              width: 'calc(100% - 2px)',
              borderRadius: '4px',
              backgroundColor: '#f6f7fb',
              border: '1px solid #dcdfec',
            }}
          >
            <Flex direction="column" justify="start" align="start" gap={0}>
              <Flex
                direction="row"
                justify="start"
                align="center"
                gap={8}
                style={{
                  padding: '24px 28px',
                  width: 'calc(100% - 56px)',
                  color: '#d83a52',
                }}
              >
                <div
                  style={{
                    lineHeight: 0,
                  }}
                >
                  <Icon icon={Alert} size={24} />
                </div>
                <Heading type="h3" ellipsis={true} color="negative">
                  {title}
                </Heading>
                <div
                  style={{
                    marginLeft: 'auto',
                  }}
                >
                  <Flex gap={16}>
                    {boardId ? (
                      <Button
                        leftIcon={Board}
                        kind="primary"
                        size="medium"
                        color="negative"
                        onClick={() => {
                          setShowBoardDiagnoseModal(true);
                        }}
                      >
                        Diagnose board
                      </Button>
                    ) : null}
                  </Flex>
                </div>
              </Flex>
              <Divider withoutMargin />
              <div style={{ padding: '24px 28px', width: 'calc(100% - 56px)', backgroundColor: '#fff' }}>
                <Flex direction="column" justify="start" align="start" gap={16}>
                  <div>{errorMessage}</div>
                  <Flex>
                    <Button
                      kind="secondary"
                      size="small"
                      color="fixed-dark"
                      preventClickAnimation
                      onClick={() => {
                        window.open('https://status.getgorilla.app', '_blank');
                      }}
                      rightFlat
                      style={{
                        marginRight: '-1px',
                        paddingRight: '12px',
                        paddingLeft: '12px',
                      }}
                    >
                      Status page
                    </Button>
                    <Button
                      kind="secondary"
                      size="small"
                      color="fixed-dark"
                      onClick={() => {
                        const errorJson = createErrorJson(error, mondayClient);
                        const blob = new Blob([JSON.stringify(errorJson, null, 2)], { type: 'application/json' });
                        const url = URL.createObjectURL(blob);
                        const a = document.createElement('a');
                        a.href = url;
                        a.download = `error-${boardId || 'unknown'}-${new Date().toISOString()}.json`;
                        a.click();
                        URL.revokeObjectURL(url);
                      }}
                      leftFlat
                      preventClickAnimation
                      style={{
                        paddingRight: '12px',
                        paddingLeft: '12px',
                      }}
                    >
                      Download report
                    </Button>
                  </Flex>
                </Flex>
              </div>
            </Flex>
          </div>
        </Flex>
      </Box>
    </>
  );
}
